import React from 'react';
import { LuckyDayRepository } from '../../repository';

const repository = new LuckyDayRepository();

class LuckyDayHomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numberCounts: []
    };
  }

  componentDidMount() {
    repository.findNumberCount(null, (data) => {
      this.setState({ numberCounts: data.numberCounts });
    });
  }

  render() {
    return (
      <>
        <div className={"className"}>
          <LuckyDayNumberCountList numberCounts={this.state.numberCounts} />
        </div>
      </>
    );
  }
}

const LuckyDayNumberCountList = (props) => {
  const { numberCounts } = props;

  const circleStyle = {
    display: "inline-block",
    minWidth: 50,
    minHeight: 50,
    lineHeight: "50px",
    borderRadius: 50
  };

  const getNumberCircleStyle = (number) => ({
    background: (number > 40) ? "#b0d840" : (number > 30) ? "#aaa" : (number > 20) ? "#ff7272" : (number > 10) ? "#69c8f2" : "#fbc400",
    color: "#fff"
  });

  return (
    <>
      <table className={"table table-middle"}>
        <thead>
          <tr>
            <th style={{ width: "10%" }}>rank</th>
            <th style={{ width: "45%" }}>Number</th>
            <th style={{ width: "45%" }}>Count</th>
          </tr>
        </thead>
        <tbody>
          {numberCounts.map((item, key) => (
            <tr key={key}>
              <td>{key + 1}</td>
              <td><span style={{ ...circleStyle, ...getNumberCircleStyle(item.number) }}>{item.number}</span></td>
              <td>{item.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export { LuckyDayHomePage };
